import { UserType } from '@/data/models/user.model';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/operatori/Operatori.vue'),
		meta: {
			title: 'operatori',
			acl: 'section.operatori'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		meta: {
			title: 'new-operatore',
			acl: 'section.operatori',
			utype: UserType.CALL_CENTER
		}
	},
	{
		path: ':utenteid/edit',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		props: true,
		meta: {
			title: 'edit-operatore',
			acl: 'section.operatori',
			utype: UserType.CALL_CENTER
		}
	}
];

export default routes;